import { Collapse, Row, Col, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dineroDisabledMask,
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import moment from "moment";
import CancelarDevolucionCompra from "../CancelarDevolucionCompra/CancelarDevolucionCompra";

const { Panel } = Collapse;

class DevolucionesFactura extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    devolucionesHtml: <p>No se encontro ninguna devolucion</p>,
    modalCancelarDevolucionCompra: false,
    modalCancelarDevolucionCompraId: null
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  verDevolucion(id){
    this.props.history.push("/panel/verDevolucionCompra", {id})
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "devolucionesCompra/notasFactura",
        { facturaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;
        const html = (
          <Collapse style={{ marginBottom: 10 }}>
            {res.data.map((valueDevolucion) => {
              return (
                <Panel
                  extra={
                    valueDevolucion.estado !== 0 ? (
                      valueDevolucion.moneda.abreviacion+' - '+dineroDisabledMask(valueDevolucion.totalPagar)
                    ) : (
                      <Tag color="red">
                        Cancelada: {valueDevolucion.moneda.abreviacion+' - '+dineroDisabledMask(valueDevolucion.totalPagar)}
                      </Tag>
                    )
                  }
                  header={moment(valueDevolucion.fechaFactura).locale("es").format("ll")}
                  key={valueDevolucion._id}
                >
                  <Row>
                    <Col span={12}>
                      <p>
                        Fecha:{" "}
                        {moment(valueDevolucion.fechaFactura).locale("es").format("ll")}
                      </p>
                      <p>
                        UUID:{" "}
                        {valueDevolucion.uuid}
                      </p>
                        <ButtonItem type="primary" onClick={() => this.verDevolucion(valueDevolucion._id)}>
                          Ver Devolucion
                        </ButtonItem>
                    </Col>
                    <Col span={12}>
                      <p>Total: {valueDevolucion.moneda.abreviacion+' - '+dineroDisabledMask(valueDevolucion.totalPagar)}</p>
                      <p>Codigo: {valueDevolucion.codigoFactura ? valueDevolucion.codigoFactura : ''}</p>
                      {valueDevolucion.estado !== 0 && (
                        <ButtonItem type="primary" danger onClick={() => {
                          this.setState({modalCancelarDevolucionCompra: true, modalCancelarDevolucionCompraId: valueDevolucion._id})
                        }}>
                          Cancelar Devolucion
                        </ButtonItem>
                      )}
                    </Col>
                  </Row>
                </Panel>
              );
            })}
          </Collapse>
        );
        this.setState({ devolucionesHtml: html });
      });
    this.setState({ loading: false });
  }
  cerrarDevolucionesFactura() {
    this.props.cerrarDevolucionesFactura();
  }
  cerrarCancelarDevolucionCompra() {
    this.setState({
      modalCancelarDevolucionCompra: false,
      modalCancelarDevolucionCompraId: null,
    });
    this.consultarTodo()
  }
  render() {
    return (
      <>
      <ModalItem
        title="Devoluciones Factura"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarDevolucionesFactura.bind(this)}
        paddingTop
      >
        {this.state.devolucionesHtml}
      </ModalItem>
      <CancelarDevolucionCompra
          visible={this.state.modalCancelarDevolucionCompra}
          id={this.state.modalCancelarDevolucionCompraId}
          cerrarCancelarDevolucionCompra={this.cerrarCancelarDevolucionCompra.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(DevolucionesFactura);
